import { useMemo } from 'react';
import { createColumns, TableColumn } from '@vtex/admin-ui';
import { Product } from '../../../shared';
import { Image, Switch, Typography } from '../../../components';

type Props = {
  isLiveEvent: boolean;
  products: Product[];
  selectedProducts: string[];
  onSwitch: ({ value, product }: any) => void;
};

export const useGetHighlightProductTableColumns = ({
  isLiveEvent,
  products,
  selectedProducts,
  onSwitch,
}: Props) => {
  const columns: TableColumn<Product>[] = useMemo(() => {
    const baseColumns: TableColumn<Product>[] = createColumns([
      {
        id: 'image',
        header: 'Image',
        resolver: {
          type: 'image',
          render: ({ data }) => <Image>{data}</Image>,
        },
      },
      {
        id: 'sku',
        header: 'SKU',
        width: '1fr',
        resolver: {
          type: 'text',
          columnType: 'text',
          mapText: item => item.sku,
          render: ({ data }) => <Typography>{data}</Typography>,
        },
      },
      {
        id: 'name',
        header: 'Name',
        width: '6fr',
        resolver: {
          type: 'text',
          columnType: 'name',
          mapText: item => item.name,
          render: ({ data }) => <Typography>{data} </Typography>,
        },
      },
      {
        id: 'actions',
        header: 'Actions',
        width: '1fr',
        resolver: {
          type: 'root',
          render: ({ item }: { item: Product }) => {
            const currentValue = !!selectedProducts.find(
              product => product === item.id,
            );

            return (
              <Switch
                value={currentValue}
                onSwitch={value => onSwitch({ value, product: item })}
                disabled={!isLiveEvent}
              />
            );
          },
        },
      },
    ]);

    const hasBrand = products.some(product => product.brand);

    if (hasBrand) {
      baseColumns.splice(3, 0, {
        id: 'brand',
        header: 'Brand',
        width: '6fr',
        resolver: {
          type: 'text',
          columnType: 'text',
          mapText: item => item.brand,
          render: ({ data }) => <Typography>{data}</Typography>,
        },
      });
    }

    return baseColumns;
  }, [products, selectedProducts, onSwitch, isLiveEvent]);

  return { columns };
};
